import { ReactElement, ReactNode } from 'react';
import cn from 'classnames';
import styles from './Table.module.scss';

export interface TableProps {
  dataRows: ReactNode[][];
  headingRow?: ReactNode[];
  scrollOnMobile?: boolean;
  classNames?: string | string[];
}

export const Table = ({
  headingRow,
  dataRows,
  scrollOnMobile,
  classNames,
}: TableProps): ReactElement => {
  const className = cn(styles.tableRoot, classNames, {
    [styles.tableScrollOnMobile]: scrollOnMobile,
  });

  return (
    <table className={className}>
      {headingRow && (
        <thead>
          <tr>
            {headingRow.map((cellContent, i) => (
              <th key={`thead-${i}`}>{cellContent}</th>
            ))}
          </tr>
        </thead>
      )}
      <tbody>
        {dataRows.map((row, i) => (
          <tr key={`tbody-tr-${i}`}>
            {row.map((cellContent, ix) => (
              <td key={`tbody-td-${ix}`}>{cellContent}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
